module.exports = __webpack_public_path__ + "img/model.b1a0280f.png";